import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";
var _hoisted_1 = {
  style: {
    "min-height": "500px"
  }
};
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = {
  class: "dialog-footer"
};
import { msgGet } from '@/api/system/message';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageContent',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var data = ref();
    var dialogVisible = ref(false);
    var open = function open(id) {
      dialogVisible.value = true;
      msgGet(id).then(function (res) {
        data.value = res.data.content;
      });
    };
    var close = function close() {
      data.value = '';
      dialogVisible.value = false;
    };
    __expose({
      open: open
    });
    return function (_ctx, _cache) {
      var _component_el_skeleton = _resolveComponent("el-skeleton");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        ref: "dialog",
        title: "详情",
        width: "65%",
        "min-height": "500px",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(dialogVisible) ? dialogVisible.value = $event : null;
        }),
        onClose: close
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
            onClick: close
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("关闭")]);
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_unref(dialogVisible) ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "my-dialog",
            innerHTML: _unref(data)
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true), !_unref(data) ? (_openBlock(), _createBlock(_component_el_skeleton, {
            key: 1,
            rows: 5,
            animated: ""
          })) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});